import { useMemo } from "react";
import { userConfiguration } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";

export enum ExchangeAvailability {
	NotAvailable = 0,
	Available = 1,
	RequiresConfiguration
}

export function useExchangeAvailability(): ExchangeAvailability {
	const result = useMemo(
		(): ExchangeAvailability => {
			const { exchange: { isEnabled, isConfigured } } = userConfiguration();
			if (!isEnabled) {
				return ExchangeAvailability.NotAvailable;
			}

			if (!isConfigured) {
				return ExchangeAvailability.RequiresConfiguration;
			}

			return ExchangeAvailability.Available;
		},
		[]
	);

	return result;
}